import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ children, onClick, variant = 'primary', className = '', ...props }) => {
  const baseStyles = "px-6 py-3 rounded-full font-bold transition-all duration-300 transform shadow-lg flex items-center justify-center gap-2";
  
  const variants = {
    primary: "bg-pink-600 text-white hover:bg-pink-700 hover:scale-105 hover:shadow-pink-600/30",
    secondary: "bg-black text-white hover:bg-gray-800 hover:scale-105 hover:shadow-gray-900/30",
    outline: "border-2 border-pink-600 text-pink-600 hover:bg-pink-50"
  };

  return (
    <motion.button
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default Button;